import { z } from 'zod';
import { IDependentInvitePageContent } from './DependentInvite.component';
import { requiredCheckbox, requiredString } from '@utils/validation';
import { commonErrors } from '@utils/error';

export const testContent: IDependentInvitePageContent = {
	pageHeader: 'Invite a dependent',
	pageInfo: `<p>Ensure your spouse, partner, or adult dependent enjoys FOLX benefits too! Invite them to create a FOLX account through your employee benefits.</p>`,
	emailLabel: 'Email',
	emailPlaceholder: 'Email address',
	overEighteenLabel:
		'I confirm that my dependent is a legal adult eligible for the benefits I provide.',
	inviteLabel: 'Invite',
	dependentInviteError:
		'<p>Woops, we could not successfully add your dependent to your account.</p>',
};

export const schema = z.object({
	email: requiredString(commonErrors.inputRequired).email(),
	over18: requiredCheckbox(commonErrors.checkRequired),
});
